import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface SitePayments {
    Cards: boolean;
}

const PAYMENTS = makeStateKey<SitePayments>('site-payments');

/// How the shop takes payment, as its policy pages state it (GET Site/Payments): cards whenever every shopper is offered
/// card (StripeSettings.CardsForEveryone - live keys, or the sandbox opened to everyone), so the FAQ, the terms, the refund
/// policy, About and the footer follow the keys with no deploy. The server render asks and carries the answer in the page,
/// so a crawler reads the same wording; if the call fails, no card is named.
@Injectable({
    providedIn: 'root'
})
export class SitePaymentsService {
    readonly cards$: Observable<boolean>;

    constructor(http: HttpClient, state: TransferState, @Inject(PLATFORM_ID) platformId: any) {
        const carried = state.get<SitePayments>(PAYMENTS, null);

        this.cards$ = (carried
            ? of(carried)
            : http.get<SitePayments>(environment.apiUrl + '/api/Site/Payments').pipe(
                tap(payments => {
                    if (isPlatformServer(platformId) && payments) {
                        state.set(PAYMENTS, payments);
                    }
                }),
                catchError(() => of(null))))
            .pipe(map(p => !!(p && p.Cards)), shareReplay(1));
    }
}
